import People from 'screens/People';
import Person from 'screens/People/Person';
import { paths } from 'routes/paths';
import { ROLES } from 'utilities/access';

const navRoutes = [
  {
    id: 'people',
    key: 'people',
    path: paths.people,
    exact: true,
    secure: true,
    disabled: false,
    component: People
  }
];

const allRoutes = [
  ...navRoutes,
  {
    id: 'personEntry',
    key: 'personEntry',
    path: `${paths.people}/:id`,
    exact: true,
    secure: true,
    component: Person,
    minPermissions: {
      minAllowedRole: ROLES.FULL_CONTROL
    }
  },
  {
    id: 'personView',
    key: 'personView',
    path: `${paths.people}/:id/:view`,
    exact: true,
    secure: true,
    component: Person
  }
];

export default { navRoutes, allRoutes };
